/**
 * @generated SignedSource<<f5e864fa424396cf6132b05d6a978a36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorPhotoFragment_staffProfile$data = {
  readonly profileImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly user: {
    readonly firstName: string;
    readonly fullName: string;
    readonly lastName: string | null | undefined;
  };
  readonly " $fragmentType": "InstructorPhotoFragment_staffProfile";
};
export type InstructorPhotoFragment_staffProfile$key = {
  readonly " $data"?: InstructorPhotoFragment_staffProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorPhotoFragment_staffProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorPhotoFragment_staffProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "profileImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StaffUser",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StaffProfile",
  "abstractKey": null
};

(node as any).hash = "cfb40649b9ecc6c651799b41a80a3dd2";

export default node;
